import React from 'react'

const TransportContainer = () => (
  <div className="has-Header Container">
    <p>for TransportContainer</p>
    <div>Catalog Header
      <p> search goods</p>
      <p> register goods to button</p>
    </div>
    <div>
      <p> Catalog List</p>
    </div>
  </div>
)

export default TransportContainer



// WEBPACK FOOTER //
// ./src/TransportGoods/containers/TransportContainer.js